const styles = (theme) => ({
  card: {
    fontSize: 16,
    background: theme.color.grey_f6,
    color: theme.color.black_33,
    borderRadius: 0,
    margin: theme.spacing(2.5, 0, 0),
    padding: theme.spacing(2.5, 3),
    border: '1px solid transparent',
    boxShadow: 'none',
    position: 'relative',
  },
  header: {
    marginBottom: theme.spacing(2.5),
    borderBottom: `1px solid ${theme.color.grey_e1}`,
    padding: 0,
  },
  title: {
    color: theme.color.black_33,
    fontSize: 16,
    lineHeight: 1.75,
    letterSpacing: 1.25,
    textTransform: 'uppercase',
    opacity: 1,
    marginBottom: theme.spacing(1.5),
  },
  action: {
    margin: 0,
  },
  btn: {
    fontSize: 14,
    letterSpacing: 1.25,
    lineHeight: 1.43,
    color: theme.color.green_7c,
    textTransform: 'uppercase',
    minWidth: 0,
    padding: 0,
    border: 0,
    borderBottom: `2px solid ${theme.color.green_7c}`,
    background: 'none',
    cursor: 'pointer',
    transition: 'color 0.3s, opacity 0.3s',

    '&:hover, &:focus': {
      color: theme.color.green_7c,
      opacity: 0.8,
      background: 'none',
    },
  },
  content: {
    padding: 0,

    '&:last-child': {
      padding: 0,
    },
  },
});

export default styles;
